import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'stripHtml',
  standalone: true,
})
export class StripHtmlPipe implements PipeTransform {
  transform(text: string | null | undefined, newlinesIntoSpaces = false, ...tagsToKeep: any[]): string {
    if (!text) return ''
    if (newlinesIntoSpaces) text = text.replace(/<\/p>/g, '</p> ')

    return tagsToKeep.length > 0
      ? text.replace(new RegExp(`<(?!\/?(${tagsToKeep.join('|')})\s*\/?)[^>]+>`, 'g'), '')
      : text.replace(/<(?:.|\s)*?>/g, '')
  }
}
